import React, {useEffect, useReducer, useState} from "react";
import ReactTable from "../../components/ReactTableWrapper";
import connection from "../../connection";
import Connection from "../../connection";
import general from "../../general";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import gestaoStyle from "assets/jss/material-dashboard-pro-react/views/gestaoStyle";
import {faEye, faEyeSlash, faFileExcel, faPlus, faSearchPlus, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Button from "../../components/CustomButtons/Button";
import SweetAlert from "../../components/SweetAlertWrapper";
import CustomInput from "../../components/CustomInput/CustomInput";
import EstadoUtilizador from "../../components/EstadoUtilizador";
import UserSearch from "../../components/UserSearch";
import CardBody from "../../components/Card/CardBody";
import Datetime from "../../components/DatetimeWrapper";
import ExtratoPortaMoedas from "../../components/ExtratoPortaMoedas";
import {SlideDown} from "react-slidedown";
import useDebounce from "../../functions/useDebounce";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Popper from "@material-ui/core/Popper";
import {primaryColor, warningColor} from "../../assets/jss/material-dashboard-pro-react";

function FAQGestao(props) {
  const {classes} = props;
  const [markdown, setMarkdown] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const carregarFAQ = async () => {
    setLoading(true);
    try {
      const dados = await connection.get("faq");
      setMarkdown(dados.markdown || "");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarFAQ();
  }, []);

  const importarMarkdown = (event) => {
    const ficheiro = event.target.files && event.target.files[0];
    if (!ficheiro)
      return;

    const reader = new FileReader();
    reader.onload = (e) => {
      setMarkdown(e.target.result || "");
    };
    reader.readAsText(ficheiro);
    event.target.value = "";
  };

  const guardarFAQ = async () => {
    setSaving(true);
    try {
      await connection.post("administracao/atualizar_faq", {markdown});
      general.success("FAQ guardada com sucesso.", "Sucesso");
    } finally {
      setSaving(false);
    }
  };

  return <Card>
    <CardHeader color="primary">
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
        <h4 style={{flex: 1}}>FAQ</h4>
      </div>
    </CardHeader>
    <CardBody>
      <p style={{marginTop: 0}}>
        Utilize `#` para secções e `##` para perguntas recolhíveis. O restante conteúdo será apresentado como resposta em Markdown.
      </p>
      <div style={{marginBottom: 20}}>
        <input
          accept=".md,text/markdown,text/plain"
          onChange={importarMarkdown}
          type="file"
        />
      </div>
      <form autoComplete="off" className={classes.cardForm}>
        <CustomInput
          labelText="Conteúdo Markdown"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            multiline: true,
            rows: 16,
            value: markdown,
            disabled: loading || saving,
            onChange: (e) => setMarkdown(e.target.value)
          }}
        />
      </form>
      <div style={{display: "flex"}}>
        <Button
          className={classes.button + " " + classes.info}
          disabled={loading || saving}
          style={{marginRight: 10, height: 25}}
          onClick={guardarFAQ}
        >{saving ? "A guardar..." : "Guardar FAQ"}</Button>
        <Button
          className={classes.button + " " + classes.primary}
          disabled={loading}
          style={{height: 25}}
          onClick={() => window.open("/faq", "_blank")}
        >Abrir FAQ</Button>
      </div>
    </CardBody>
  </Card>;
}

function SaltarEspera(props) {
  const {classes} = props;
  const [nin, setNin] = useState(null);
  const [saltar_modulos_presenciais_ipe, setSaltarModulosPresenciaisIPE] = useState(false);
  const [saltar_espera_parecer_pdpe, setSaltarEsperaParecerPDPE] = useState(false);
  const [saltar_espera_parecer_pfe, setSaltarEsperaParecerPFE] = useState(false);

  const saltarFaseEspera = async () => {
    if (!nin)
      return;
    let utilizador = await connection.post("utilizador/saltar_estado_espera?utilizador", {
      nin_utilizador: nin,
      saltar_espera_parecer_pdpe: saltar_espera_parecer_pdpe,
      saltar_espera_parecer_pfe: saltar_espera_parecer_pfe,
      saltar_modulos_presenciais_ipe: saltar_modulos_presenciais_ipe
    })
    general.success(`Fases em espera de ${utilizador.nome_curto} (${utilizador.NIN}) saltadas com sucesso.`, "Sucesso");
  }

  return <Card>
    <CardHeader color="primary">
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxHeight: "45px"}}>
        <h4 style={{flex: 1}}>Saltar Fases de Espera</h4>
      </div>
    </CardHeader>
    <CardBody>
      <form autoComplete="off" className={classes.cardForm}>
        <UserSearch
          labelText="NIN ou Email do Utilizador"
          skipStatusCheck
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            name: "user_id"
          }}
          onFoundUser={(user) => {
            setNin(user.NIN)
          }}
          onUserNotFound={nin => {
            setNin(nin)
          }}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={saltar_espera_parecer_pdpe}
              tabIndex={-1}
              onClick={() => {
                setSaltarEsperaParecerPDPE(!saltar_espera_parecer_pdpe)
              }}
              checkedIcon={<Check className={classes.checkedIcon}/>}
              icon={<Check className={classes.uncheckedIcon}/>}
              classes={{
                checked: classes.checked
              }}
            />
          }
          classes={{
            label: classes.label
          }}
          label={"Saltar espera Parecer PDPE"}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={saltar_espera_parecer_pfe}
              tabIndex={-1}
              onClick={() => {
                setSaltarEsperaParecerPFE(!saltar_espera_parecer_pfe)
              }}
              checkedIcon={<Check className={classes.checkedIcon}/>}
              icon={<Check className={classes.uncheckedIcon}/>}
              classes={{
                checked: classes.checked
              }}
            />
          }
          classes={{
            label: classes.label
          }}
          label={"Saltar espera Parecer PFE"}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={saltar_modulos_presenciais_ipe}
              tabIndex={-1}
              onClick={() => {
                setSaltarModulosPresenciaisIPE(!saltar_modulos_presenciais_ipe)
              }}
              checkedIcon={<Check className={classes.checkedIcon}/>}
              icon={<Check className={classes.uncheckedIcon}/>}
              classes={{
                checked: classes.checked
              }}
            />
          }
          classes={{
            label: classes.label
          }}
          label={"Saltar espera dos módulos presenciais do IPE"}
        />
      </form>
      <Button
        className={classes.button + " " + classes.info}
        style={{padding: "4px 12px 4px 12px", marginLeft: "10px!important"}}
        onClick={saltarFaseEspera}
      >Saltar Fases</Button>
    </CardBody>
  </Card>
}

function AtualizarParticipacaoPercurso(props) {
  const {classes} = props;
  const [nin, setNin] = useState(null);
  const [codigo_percurso, setCodigoPercurso] = useState(null);
  const atualizarFluxo = async () => {
    if (!nin)
      return;

    let dados_atualizacaao = {
      nin_utilizador: nin,
      codigo_percurso: codigo_percurso
    }

    let utilizador = await connection.post("ferramentas/atualizar_participacao_percurso", dados_atualizacaao)
    general.success(`O fluxo do utilizador ${utilizador.nome_curto} (${utilizador.NIN}) foi avançado com sucesso.`, "Sucesso");
  }

  return <Card>
    <CardHeader color="primary">
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxHeight: "45px"}}>
        <h4 style={{flex: 1}}>Atualizar Participação em Percurso</h4>
      </div>
    </CardHeader>
    <CardBody>
      <form autoComplete="off" className={classes.cardForm}>
        <CustomInput
          labelText="Código do percurso"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            name: "designacao",
            onChange: (e) => {
              setCodigoPercurso(e.target.value);
            }
          }}
        />
        <UserSearch
          labelText="NIN ou Email do Utilizador"
          skipStatusCheck
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            name: "user_id"
          }}
          onFoundUser={(user) => {
            setNin(user.NIN)
          }}
          onUserNotFound={nin => {
            setNin(nin)
          }}
        />
      </form>
      <Button
        className={classes.button + " " + classes.info}
        style={{padding: "4px 12px 4px 12px", marginLeft: "10px!important"}}
        onClick={atualizarFluxo}
      >Atualizar Fluxo</Button>
    </CardBody>
  </Card>;
}

function AtualizarUtilizador(props) {
  const {classes} = props;
  const [nin, setNin] = useState(null);
  const atualizarUtilizador = async () => {
    if (!nin)
      return;
    await connection.get("ferramentas/atualizar_utilizador", {nin})
    general.success("Informações do utilizador atualizadas com sucesso.", "Sucesso");
  }

  return <Card>
    <CardHeader color="primary">
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxHeight: "45px"}}>
        <h4 style={{flex: 1}}>Atualizar Utilizador</h4>
      </div>
    </CardHeader>
    <CardBody>
      <form autoComplete="off" className={classes.cardForm} onSubmit={atualizarUtilizador}>
        <UserSearch
          labelText="NIN ou Email do Utilizador"
          skipStatusCheck
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            name: "user_id"
          }}
          onFoundUser={(user) => {
            setNin(user.NIN)
          }}
          onUserNotFound={nin => {
            setNin(nin)
          }}
        />
      </form>
      <Button
        className={classes.button + " " + classes.info}
        style={{padding: "4px 12px 4px 12px", marginLeft: "10px!important"}}
        onClick={atualizarUtilizador}
      >Atualizar</Button>
    </CardBody>
  </Card>;
}

function ValidarCertificado(props) {
  const {classes} = props;
  const [utilizador, setUtilizador] = useState(null);
  const [codigo, setCodigo] = useState("");
  const [resultado, setResultado] = useState(null);
  const [erro, setErro] = useState(null);

  const limparResultado = () => {
    setResultado(null);
    setErro(null);
  };

  const validarCertificado = async () => {
    limparResultado();

    if (!utilizador?.id || !codigo.trim())
      return setErro("Indique o formando e o código de validação");

    try {
      // disableNotif: o erro é apresentado aqui em baixo em vez de ir para uma notificação
      setResultado(await connection.get("administracao/certificado/validar", {
        utilizador: utilizador.id,
        codigo: codigo.trim()
      }, null, null, {returnError: true, disableNotif: true}));
    } catch (e) {
      let mensagem = Array.isArray(e?.message) ? e.message.join(" ") : e?.message;
      setErro(mensagem || "Não foi possível validar o certificado");
    }
  };

  return <Card>
    <CardHeader color="primary">
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxHeight: "45px"}}>
        <h4 style={{flex: 1}}>Validar Certificado</h4>
      </div>
    </CardHeader>
    <CardBody>
      <form autoComplete="off" className={classes.cardForm}>
        <UserSearch
          labelText="NIN do Formando"
          skipStatusCheck
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            name: "user_id"
          }}
          onFoundUser={(user) => {
            setUtilizador(user);
            limparResultado();
          }}
          onUserNotFound={() => {
            setUtilizador(null);
            limparResultado();
          }}
        />
        <CustomInput
          labelText="Código de validação"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            name: "codigo",
            value: codigo,
            onChange: (e) => {
              setCodigo(e.target.value.toUpperCase());
              limparResultado();
            }
          }}
        />
      </form>
      {erro && <div style={{marginTop: 10, marginBottom: 20, maxWidth: 340, overflowWrap: "break-word"}}>
        <h4 style={{color: warningColor, fontWeight: 400, fontSize: 16, margin: 0}}>{erro}</h4>
      </div>}
      {resultado && <div style={{marginTop: 10, marginBottom: 20, maxWidth: 340, overflowWrap: "break-word"}}>
        <h4 style={{color: resultado.valido ? primaryColor : warningColor, fontWeight: 400, fontSize: 16, margin: 0}}>
          {resultado.valido ? "Certificado válido" : "Certificado inválido"}
        </h4>
        {resultado.motivo && <p style={{color: warningColor, margin: 0}}>{resultado.motivo}</p>}
        <p style={{margin: "6px 0 0"}}>
          <span style={{fontWeight: 500}}>{resultado.certificado.nome}</span> | {resultado.certificado.nin}<br/>
          {resultado.certificado.modulo}<br/>
          {resultado.certificado.data_inicio}
          {resultado.certificado.data_fim !== resultado.certificado.data_inicio && <> a {resultado.certificado.data_fim}</>}
          <br/>
          Avaliação: {resultado.certificado.avaliacao}/100 · Créditos: {resultado.certificado.creditos}
        </p>
      </div>}
      <Button
        className={classes.button + " " + classes.info}
        style={{padding: "4px 12px 4px 12px", marginLeft: "10px!important"}}
        onClick={validarCertificado}
      >Validar</Button>
    </CardBody>
  </Card>;
}

function CancelarFluxoUtilizadorPRA(props) {
  const {classes} = props;
  const [nin, setNin] = useState(null);
  const cancelarParticipacao = async () => {
    if (!nin)
      return;
    await connection.post("ferramentas/cancelar_participacao_percurso_regresso_ativo", {nin_utilizador: nin})
    general.success("Participação cancelada com sucesso.", "Sucesso");
  }

  return <Card>
    <CardHeader color="primary">
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxHeight: "45px"}}>
        <h4 style={{flex: 1}}>Cancelar Participação em PRA</h4>
      </div>
    </CardHeader>
    <CardBody>
      <form autoComplete="off" className={classes.cardForm} onSubmit={cancelarParticipacao}>
        <UserSearch
          labelText="NIN ou Email do Utilizador"
          skipStatusCheck
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            name: "user_id"
          }}
          onFoundUser={(user) => {
            setNin(user.NIN)
          }}
          onUserNotFound={nin => {
            setNin(nin)
          }}
        />
      </form>
      <Button
        className={classes.button + " " + classes.info}
        style={{padding: "4px 12px 4px 12px", marginLeft: "10px!important"}}
        onClick={cancelarParticipacao}
      >Cancelar Participação</Button>
    </CardBody>
  </Card>;
}

function ListarAdministradores(props) {
  const {classes} = props;
  const [administradores, setAdministradores] = useState(null);

  const [state, setState] = useReducer(
    (state, newState) => ({...state, ...newState}),
    {
      filter: "",
      page: 0,
      pageSize: 10
    });
  const debouncedFilter = useDebounce(state.filter, 500);

  const obterDados = async () => {
    setAdministradores(await connection.get("utilizador/listar_administradores", {filtro: state.filter}));
  }

  useEffect(() => {
    obterDados();
  }, [debouncedFilter]);

  const adicionarAdministrador = async () => {
    let utilizador = null;

    let Content = () => {
      return <form autoComplete="off" className={classes.alertForm}>
        <UserSearch
          labelText="NIN do Administrador"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            name: "administrador"
          }}
          onFoundUser={(user) => {
            utilizador = user.NIN;
          }}
        />
      </form>;
    };

    window.App.openModal(<SweetAlert
      style={{width: 520}}
      title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
        <span className={classes.modalCardTitle}>Novo Administrador</span>
      </div>)}
      onConfirm={() => {
        connection.post("utilizador/adicionar/administrador", {administrador: utilizador}, (data) => {
          window.App.hideModal();
          obterDados();
        });
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnText="Adicionar"
      showCancel
      cancelBtnText="Cancelar"
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }
    >
      <Content/>
    </SweetAlert>);
  }

  const removerAdministrador = async (administrador) => {
    window.App.openModal(<SweetAlert
      warning
      title="Remover Administrador"
      onConfirm={() => {
        connection.post("utilizador/remover/administrador", {administrador: administrador.NIN}, (data) => {
          window.App.hideModal();
          obterDados();
        });
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }
      confirmBtnText="Remover"
      cancelBtnText="Cancelar"
      showCancel
    >
      Tem a certeza que pretende remover o cargo 'Administrador' de {administrador.nome_curto} ({administrador.NIN})?
    </SweetAlert>);
  }

  return <GridItem xs={12} sm={6}>
    <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxHeight: "45px"}}>
          <h4 style={{flex: 1}}>Administradores</h4>
          <Button
            style={{marginRight: "10px"}}
            className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
            onClick={() => adicionarAdministrador()}
            color="success"
          >
            <FontAwesomeIcon icon={faPlus}/> Adicionar
          </Button>
          <CustomInput
            id="tableSearch"
            formControlProps={{
              className: classes.searchInput
            }}
            inputProps={{
              type: "text",
              name: "tableSearch",
              placeholder: "Pesquisar",
              onChange: (e) => {
                setState({filter: e.target.value, page: 0});
              }
            }}
          />
        </div>
      </CardHeader>
      <ReactTable
        data={administradores}
        minRows={1}
        columns={[
          {
            Header: "Nome",
            accessor: "nome_curto",
            maxWidth: 700,
            Cell: (row) => <span>
                    <EstadoUtilizador nome={row.value} estado={row.original.estado}/>
                    <span style={{fontSize: 10, display: "block", marginTop: -3, color: "#5e5e5e"}}>{row.original.agrupamento + (row.original.nucleo ? " / " + row.original.nucleo : '') + (row.original.regiao ? " / " + row.original.regiao : '')}</span>
                  </span>
          },
          {
            Header: "NIN",
            accessor: "NIN",
            maxWidth: 600
          },
          {
            Header: "",
            accessor: "actions",
            sortable: false,
            maxWidth: 100,
            Cell: ({original}) => <div>
              <Button
                justIcon
                round
                simple
                style={{margin: 0}}
                onClick={() => {
                  removerAdministrador(original);
                }}
                color="danger"
                className="edit"
              >
                <FontAwesomeIcon icon={faTrashAlt}/>
              </Button>
            </div>
          }
        ]}
        defaultPageSize={10}
        showPaginationBottom={true}
        className="-striped -highlight"
      />
    </Card>
  </GridItem>;
}

function ListarChefesNacionais(props) {
  const {classes} = props;
  const [utilizadores, setUtilizadores] = useState(null);

  const plural = "Chefes Nacionais";
  const singular = "Chefe Nacional";
  const cargo = "chefe_nacional";

  const [state, setState] = useReducer(
    (state, newState) => ({...state, ...newState}),
    {
      filter: "",
      page: 0,
      pageSize: 10
    });
  const debouncedFilter = useDebounce(state.filter, 500);

  const obterDados = async () => {
    setUtilizadores(await connection.get("utilizador/listagem/" + cargo, {filter: state.filter}));
  }

  useEffect(() => {
    obterDados();
  }, [debouncedFilter]);

  const adicionar = async () => {
    let utilizador = null;

    let Content = () => {
      return <form autoComplete="off" className={classes.alertForm}>
        <UserSearch
          labelText={"NIN do " + singular}
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
          }}
          onFoundUser={(user) => {
            utilizador = user.NIN;
          }}
        />
      </form>;
    };

    window.App.openModal(<SweetAlert
      style={{width: 520}}
      title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
        <span className={classes.modalCardTitle}>Atribuir {singular}</span>
      </div>)}
      onConfirm={() => {
        connection.post("utilizador/adicionar/cargos_temporarios", {nin_utilizador: utilizador, cargo_temporario: cargo}, (data) => {
          window.App.hideModal();
          obterDados();
        });
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnText="Adicionar"
      showCancel
      cancelBtnText="Cancelar"
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }
    >
      <Content/>
    </SweetAlert>);
  }

  const remover = async (utilizador) => {
    window.App.openModal(<SweetAlert
      warning
      title={"Remover " + singular}
      onConfirm={() => {
        connection.post("utilizador/remover/cargos_temporarios", {nin_utilizador: utilizador.NIN, cargo_temporario: cargo}, (data) => {
          window.App.hideModal();
          obterDados();
        });
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }
      confirmBtnText="Remover"
      cancelBtnText="Cancelar"
      showCancel
    >
      Tem a certeza que pretende remover o cargo '{singular}' de {utilizador.nome_curto} ({utilizador.NIN})?
    </SweetAlert>);
  }

  return <GridItem xs={12} sm={6}>
    <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxHeight: "45px"}}>
          <h4 style={{flex: 1}}>{plural}</h4>
          <Button
            style={{marginRight: "10px"}}
            className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
            onClick={() => adicionar()}
            color="success"
          >
            <FontAwesomeIcon icon={faPlus}/> Adicionar
          </Button>
          <CustomInput
            id="tableSearch"
            formControlProps={{
              className: classes.searchInput
            }}
            inputProps={{
              type: "text",
              name: "tableSearch",
              placeholder: "Pesquisar",
              onChange: (e) => {
                setState({filter: e.target.value, page: 0});
              }
            }}
          />
        </div>
      </CardHeader>
      <ReactTable
        data={utilizadores?.users}
        minRows={1}
        columns={[
          {
            Header: "Nome",
            accessor: "nome",
            maxWidth: 700,
            Cell: (row) => <span>
                    <EstadoUtilizador nome={row.value}/>
                    <span style={{fontSize: 10, display: "block", marginTop: -3, color: "#5e5e5e"}}>{row.original.agrupamento + (row.original.nucleo ? " / " + row.original.nucleo : '') + (row.original.regiao ? " / " + row.original.regiao : '')}</span>
                  </span>
          },
          {
            Header: "NIN",
            accessor: "NIN",
            maxWidth: 600
          },
          {
            Header: "",
            accessor: "actions",
            sortable: false,
            maxWidth: 100,
            Cell: ({original}) => <div>
              <Button
                justIcon
                round
                simple
                style={{margin: 0}}
                onClick={() => {
                  remover(original);
                }}
                color="danger"
                className="edit"
              >
                <FontAwesomeIcon icon={faTrashAlt}/>
              </Button>
            </div>
          }
        ]}
        defaultPageSize={10}
        showPaginationBottom={true}
        className="-striped -highlight"
      />
    </Card>
  </GridItem>;
}

function ListaParticipacoesCursos(props) {
  const {classes} = props;
  const [tipos_curso, setTipoCurso] = useState(null);
  const [listar_tipo, setListarTipo] = useState(null);
  const [data_desde, setDataDesde] = useState(null);
  const [data_ate, setDataAte] = useState(null);

  const obterDados = async () => {
    setTipoCurso(await connection.get("curso/listagem_tipos"));
  }

  useEffect(() => {
    obterDados();
  }, []);

  return <Card>
    <CardHeader color="primary">
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxHeight: "45px"}}>
        <h4 style={{flex: 1}}>Relatórios de Curso</h4>
      </div>
    </CardHeader>
    <CardBody>
      <form autoComplete="off" className={classes.cardForm}>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="tipo_curso" className={classes.selectLabel}>
            Tipo de Curso
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu,
            }}
            classes={{
              select: classes.select
            }}
            value={listar_tipo}
            onChange={(event) => {
              setListarTipo(event.target.value)
            }}
            inputProps={{
              name: "tipo_curso",
              id: "tipo_curso"
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione o tipo de curso</MenuItem>
            {tipos_curso?.map((tipo) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={tipo.codigo}>{tipo.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Cursos que se iniciaram a partir de:
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              setDataDesde(value)
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={"H:mm"}
          />
        </FormControl>
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Cursos que terminaram até:
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              setDataAte(value)
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={"H:mm"}
          />
        </FormControl>
      </form>
      <a className={classes.addStuffButton + " " + classes.button + " " + classes.info}
         style={{marginRight: "8px"}}
         target={'_blank'}
         href={Connection.getFullUrl("curso/listagem/exportar", {tipo_curso: listar_tipo, data_desde, data_ate})}>
        <FontAwesomeIcon icon={faFileExcel}/> Exportar Cursos
      </a>
      <a className={classes.addStuffButton + " " + classes.button + " " + classes.info}
         target={'_blank'}
         href={Connection.getFullUrl("curso/listagem/exportar_participacoes", {tipo_curso: listar_tipo, data_desde, data_ate})}>
        <FontAwesomeIcon icon={faFileExcel}/> Exportar Qualificações
      </a>
    </CardBody>
  </Card>;
}

function ListaParticipacoesModulos(props) {
  const {classes} = props;
  const [modulos, setModulos] = useState(null);
  const [moduloSelecionado, setModuloSelecionado] = useState(0);
  const [data_desde, setDataDesde] = useState(null);
  const [data_ate, setDataAte] = useState(null);

  const obterDados = async () => {
    setModulos(await connection.get("modulo/listagem"));
  }

  useEffect(() => {
    obterDados();
  }, []);

  return <Card>
    <CardHeader color="primary">
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxHeight: "45px"}}>
        <h4 style={{flex: 1}}>Relatórios de Módulo</h4>
      </div>
    </CardHeader>
    <CardBody>
      <form autoComplete="off" className={classes.cardForm}>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="tipo_curso" className={classes.selectLabel}>
            Módulo
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={moduloSelecionado}
            onChange={(event) => {
              setModuloSelecionado(event.target.value)
            }}
          >
            <MenuItem classes={{root: classes.selectMenuItem}} value={0}>Todos os módulos</MenuItem>
            {modulos?.map((tipo) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={tipo.id}>{tipo.codigo + ' | ' + tipo.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Módulos que se iniciaram a partir de:
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              setDataDesde(value)
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={"H:mm"}
          />
        </FormControl>
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Módulos que terminaram até:
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              setDataAte(value)
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={"H:mm"}
          />
        </FormControl>
      </form>
      <a className={classes.addStuffButton + " " + classes.button + " " + classes.info}
         style={{marginRight: "8px"}}
         target={'_blank'}
         href={Connection.getFullUrl("formacao/listagem/exportar", {modulo: moduloSelecionado || undefined, data_desde, data_ate})}>
        <FontAwesomeIcon icon={faFileExcel}/> Exportar Módulos
      </a>
      <a className={classes.addStuffButton + " " + classes.button + " " + classes.info}
         target={'_blank'}
         href={Connection.getFullUrl("formacao/listagem/exportar_participacoes", {modulo: moduloSelecionado || undefined, data_desde, data_ate})}>
        <FontAwesomeIcon icon={faFileExcel}/> Exportar Qualificações
      </a>
    </CardBody>
  </Card>;
}

function ListaInteressadosPE(props) {
  const {classes} = props;

  return <Card>
    <CardHeader color="primary">
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxHeight: "45px"}}>
        <h4 style={{flex: 1}}>Interessados Percursos Educadores</h4>
      </div>
    </CardHeader>
    <CardBody>
      <a className={classes.addStuffButton + " " + classes.button + " " + classes.info}
         target={'_blank'}
         href={Connection.getFullUrl("percurso/listagem_interessados_pe")}>
        <FontAwesomeIcon icon={faFileExcel}/> Exportar Listagem
      </a>
    </CardBody>
  </Card>;
}

function AtualizarEstadoParticipacao(props) {
  const {classes} = props;
  const [nin, setNin] = useState(null);
  const [codigo_curso, setCodigoCurso] = useState(null);
  const [recalcular_para_todos, setRecalcularParaTodos] = useState(false);
  const [atualizar_relatorio, setAtualizarRelatorio] = useState(false);
  const [incluir_modulos_extra_enriquecimento, setIncluirModulosExtraEnriquecimento] = useState(false);
  const [incluir_modulos_desativados, setIncluirModulosDesativados] = useState(false);

  const atualizarParticipacao = async () => {
    if (!recalcular_para_todos && !nin)
      return;
    await connection.post("ferramentas/recalcular_estado_participacao_curso", {
      nin_utilizador: nin,
      codigo_curso: codigo_curso,
      recalcular_para_todos: recalcular_para_todos,
      atualizar_relatorio: atualizar_relatorio,
      incluir_modulos_extra_enriquecimento: incluir_modulos_extra_enriquecimento,
      incluir_modulos_desativados: incluir_modulos_desativados
    });
    general.success(`Participação recalculada com sucesso.`, "Sucesso");
  }

  return <Card>
    <CardHeader color="primary">
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxHeight: "45px"}}>
        <h4 style={{flex: 1}}>Atualizar Participação em Curso</h4>
      </div>
    </CardHeader>
    <CardBody>
      <form autoComplete="off" className={classes.cardForm} onSubmit={atualizarParticipacao}>
        <CustomInput
          labelText="Código do curso"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            name: "designacao",
            onChange: (e) => {
              setCodigoCurso(e.target.value);
            }
          }}
        />
        {!recalcular_para_todos && <UserSearch
          labelText="NIN ou Email do Utilizador"
          skipStatusCheck
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            name: "user_id"
          }}
          onFoundUser={(user) => {
            setNin(user.NIN)
          }}
          onUserNotFound={nin => {
            setNin(nin)
          }}
        />}
        <FormControlLabel
          control={
            <Checkbox
              checked={recalcular_para_todos}
              tabIndex={-1}
              onClick={() => {
                setRecalcularParaTodos(!recalcular_para_todos)
                setNin(null)
              }}
              checkedIcon={<Check className={classes.checkedIcon}/>}
              icon={<Check className={classes.uncheckedIcon}/>}
              classes={{
                checked: classes.checked
              }}
            />
          }
          classes={{
            label: classes.label
          }}
          label={"Recalcular para todos os participantes do curso"}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={atualizar_relatorio}
              tabIndex={-1}
              onClick={() => {
                setAtualizarRelatorio(!atualizar_relatorio)
              }}
              checkedIcon={<Check className={classes.checkedIcon}/>}
              icon={<Check className={classes.uncheckedIcon}/>}
              classes={{
                checked: classes.checked
              }}
            />
          }
          classes={{
            label: classes.label
          }}
          label={"Atualizar relatório do curso"}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={incluir_modulos_extra_enriquecimento}
              tabIndex={-1}
              onClick={() => {
                setIncluirModulosExtraEnriquecimento(!incluir_modulos_extra_enriquecimento)
              }}
              checkedIcon={<Check className={classes.checkedIcon}/>}
              icon={<Check className={classes.uncheckedIcon}/>}
              classes={{
                checked: classes.checked
              }}
            />
          }
          classes={{
            label: classes.label
          }}
          label={"Incluir módulos optativos da Farol"}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={incluir_modulos_desativados}
              tabIndex={-1}
              onClick={() => {
                setIncluirModulosDesativados(!incluir_modulos_desativados)
              }}
              checkedIcon={<Check className={classes.checkedIcon}/>}
              icon={<Check className={classes.uncheckedIcon}/>}
              classes={{
                checked: classes.checked
              }}
            />
          }
          classes={{
            label: classes.label
          }}
          label={"Incluir módulos desativados da Farol"}
        />
      </form>
      <Button
        className={classes.button + " " + classes.info}
        style={{padding: "4px 12px 4px 12px", marginLeft: "10px!important"}}
        onClick={atualizarParticipacao}
      >Atualizar Participação</Button>
    </CardBody>
  </Card>;
}

function Gestao(props) {
  const {classes} = props

  const [extratosPagamentos, setExtratosPagamentos] = useState(null);
  const [regioesPagamentos, setRegioesPagamentos] = useState(null);

  const [creditoPortaMoedas, setCreditoPortaMoedas] = useState(null);
  const [regioesCreditos, setRegioesCreditos] = useState(null);

  const [ferramentaAberta, setFerramentaAberta] = useState(null);

  const [state, setState] = useReducer(
    (state, newState) => ({...state, ...newState}),
    {
      filter: "",
      page: 0,
      pageSize: 10
    });
  const debouncedFilter = useDebounce(state.filter, 500);

  const [mostrarTodos, setMostrarTodos] = useState(false);

  const obterDados = async () => {
    setExtratosPagamentos(await connection.get("pagamentos/listar_pagamentos"));
    setRegioesPagamentos(await connection.get("regiao/listagem"));

    setCreditoPortaMoedas(await connection.get("pagamentos/listar_creditos_porta_moedas", {mostrarTodos: mostrarTodos, filtro: state.filter}));
    setRegioesCreditos(await connection.get("regiao/listagem"));
  }

  useEffect(() => {
    obterDados();
  }, [mostrarTodos, debouncedFilter]);

  const filtrarPagamentosPorRegiao = async (regiao) => {
    setExtratosPagamentos(await connection.get("pagamentos/listar_pagamentos/" + regiao));
  }

  const filtrarCreditosPorRegiao = async (regiao) => {
    setCreditoPortaMoedas(await connection.get("pagamentos/listar_creditos_porta_moedas/" + regiao, {mostrarTodos: mostrarTodos, filtro: state.filter}));
  }

  const marcarReembolso = async (dados_credito) => {
    const {classes} = props;

    let valor_reembolsado = null;
    let observacao = null;

    window.App.openModal(<SweetAlert
      style={{width: 520}}
      title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
        <span className={classes.modalCardTitle}>Marcar reembolso</span>
      </div>)}
      onConfirm={async () => {
        await connection.post("pagamentos/marcar_reembolsado", {
          id_credito: dados_credito.id,
          valor_reembolsado: valor_reembolsado,
          observacao: observacao
        });
        window.App.hideModal();
        general.success("Reembolso marcado com sucesso", "Sucesso");
        obterDados();
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnText="Confirmar"
      showCancel
      cancelBtnText="Cancelar"
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }
    >
      <form autoComplete="off" style={{padding: "0 10px"}}>
        <CustomInput
          labelText="Valor reembolsado"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            name: "valor_reembolsado",
            onChange: (e) => {
              valor_reembolsado = e.target.value;
            }
          }}
        />
      </form>
      <form autoComplete="off" style={{padding: "0 10px"}}>
        <CustomInput
          labelText="Observação"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            name: "observacao",
            onChange: (e) => {
              observacao = e.target.value;
            }
          }}
        />
      </form>
    </SweetAlert>);
  }

  function abrirFerramenta(ferramenta, el) {
    setFerramentaAberta({
      anchorEl: el,
      content: ferramenta
    })
    /*window.App.openModal(<SweetAlert
      showClose
      style={{width: 600, padding: 0}}
      style_options={{right: 6}}
      onClose={window.App.hideModal}
      showConfirm={false}
      showCancel={false}
    >
      {ferramenta}
    </SweetAlert>);*/
  }

  return (<>
    <div className={classes.gestaoContainer}>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxHeight: "45px"}}>
                <h4 style={{flex: 1}}>Extratos de Pagamentos</h4>
                {general.userHasType("admin", "chefe_nacional") && <FormControl className={classes.selectFormControl} style={{width: "200px"}}>
                  <InputLabel htmlFor="regiao" className={classes.selectLabel} style={{paddingLeft: "10px"}}>
                    Região
                  </InputLabel>
                  <Select
                    style={{margin: "10px", height: "40px"}}
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    classes={{
                      select: classes.select
                    }}
                    onChange={(event) => {
                      return filtrarPagamentosPorRegiao(event.target.value);
                    }}
                  >
                    <MenuItem value={''} classes={{root: classes.selectMenuItem}}>Selecione a região</MenuItem>
                    {regioesPagamentos?.map((regiao) => {
                      return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={regiao.id}>{regiao.designacao}</MenuItem>;
                    })}
                  </Select>
                </FormControl>}
              </div>
            </CardHeader>
            <ReactTable
              data={extratosPagamentos}
              minRows={1}
              columns={[
                {
                  Header: "Mês / Ano",
                  id: "mesAno",
                  accessor: (d) => d.mes <= 9 ? ('0' + d.mes + ' / ' + d.ano) : (d.mes + ' / ' + d.ano),
                },
                {
                  Header: "Região",
                  accessor: "designacao_regiao",
                },
                {
                  Header: "Nº Pagamentos",
                  accessor: "num_pagamentos",
                },
                {
                  Header: "Valor Total",
                  Cell: ({original}) => <span>{original.valor_total.toFixed(2) + "€"}</span>,
                },
                {
                  Header: "",
                  accessor: "actions",
                  sortable: false,
                  maxWidth: 200,
                  Cell: ({original}) => <div>
                    <a className={classes.addStuffButton + " " + classes.button + " " + classes.info}
                       target={'_blank'}
                       href={Connection.getFullUrl("pagamentos/listar_pagamentos", {mes: original.mes, ano: original.ano, regiao: original.regiao, exportar_extratos: true})}>
                      <FontAwesomeIcon icon={faFileExcel}/> Exportar Extrato
                    </a>
                  </div>
                }
              ]}
              defaultPageSize={10}
              showPaginationBottom={true}
              className="-striped -highlight"
            />
          </Card>
        </GridItem>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxHeight: "45px"}}>
                <h4 style={{flex: 1}}>Porta Moedas</h4>
                <Button
                  style={{marginRight: "10px"}}
                  className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
                  onClick={() => setMostrarTodos(!mostrarTodos)}
                  color="success">
                  <FontAwesomeIcon icon={mostrarTodos ? faEyeSlash : faEye}/> {mostrarTodos ? "Apenas Saldo Positivo" : "Mostrar Todos"}
                </Button>
                <CustomInput
                  id="tableSearch"
                  formControlProps={{
                    className: classes.searchInput
                  }}
                  inputProps={{
                    type: "text",
                    name: "tableSearch",
                    placeholder: "Pesquisar",
                    onChange: (e) => {
                      setState({filter: e.target.value, page: 0});
                    }
                  }}
                />
                {general.userHasType("admin", "chefe_nacional") && <>
                  <FormControl className={classes.selectFormControl} style={{width: "200px"}}>
                    <InputLabel htmlFor="regiao" className={classes.selectLabel} style={{paddingLeft: "10px"}}>
                      Região
                    </InputLabel>
                    <Select
                      style={{margin: "10px", height: "44px"}}
                      MenuProps={{
                        className: classes.selectMenu
                      }}
                      classes={{
                        select: classes.select
                      }}
                      onChange={(event) => {
                        return filtrarCreditosPorRegiao(event.target.value);
                      }}
                    >
                      <MenuItem value={''} classes={{root: classes.selectMenuItem}}>Selecione a região</MenuItem>
                      {regioesCreditos?.map((regiao) => {
                        return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={regiao.id}>{regiao.designacao}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </>}
              </div>
            </CardHeader>
            <ReactTable
              data={creditoPortaMoedas}
              minRows={1}
              SubComponent={(row) => <SlideDown className={'my-dropdown-slidedown'}>
                {row.original.extrato && <div className={classes.wrapper}>
                  <ExtratoPortaMoedas stories={JSON.parse(row.original.extrato).map((e, i) => {
                    return {
                      inverted: false,
                      estado: e.acao,
                      designacao: e.designacao,
                      saldo_inicial: e.saldo_inicial,
                      valor: e.valor,
                      saldo_final: e.saldo_final,
                      data: e.data,
                      descricao: e.descricao
                    };
                  })}></ExtratoPortaMoedas>
                </div>}
              </SlideDown>}
              columns={[
                {
                  Header: "Nome",
                  accessor: "nome_curto",
                  maxWidth: 1000,
                  Cell: (row) => <span>
                    <a style={{cursor: "pointer"}} target={"_self"} onClick={() => {
                      window.App.hist.push("/perfil/" + row.original.id_utilizador);
                    }}>
                    <EstadoUtilizador nome={row.value} estado={row.original.estado}/>
                    <FontAwesomeIcon icon={faSearchPlus} style={{cursor: "pointer", marginLeft: "5px", color: "grey"}}/></a>
                    <span style={{fontSize: 10, display: "block", marginTop: -3, color: "#5e5e5e"}}>{row.original.agrupamento + (row.original.nucleo ? " / " + row.original.nucleo : '') + (row.original.regiao ? " / " + row.original.regiao : '')}</span>
                  </span>
                },
                {
                  Header: "Região",
                  accessor: "regiao_credito",
                  maxWidth: 200
                },
                {
                  Header: "Saldo",
                  Cell: ({original}) => <span>{original.saldo.toFixed(2) + "€"}</span>,
                  sortable: true,
                  maxWidth: 100
                },
                general.userHasPermission("utilizador.editar_credito") && {
                  Header: "",
                  accessor: "actions",
                  sortable: false,
                  maxWidth: 200,
                  Cell: ({original}) => <div>
                    <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} style={{width: "170px", height: "25px"}} onClick={() => marcarReembolso(original)}>
                      Marcar reembolso
                    </Button>
                  </div>
                }
              ].filter(Boolean)}
              defaultPageSize={10}
              showPaginationBottom={true}
              className="-striped -highlight"
            />
          </Card>
        </GridItem>

        {general.userHasType("admin") && <>
          <ListarAdministradores classes={classes}/>
          <ListarChefesNacionais classes={classes}/>
        </>}

        <GridItem xs={12} md={6}>
          <Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxHeight: "45px"}}>
                <h4 style={{flex: 1}}>Ferramentas</h4>
              </div>
            </CardHeader>
            <div className="ReactTable -striped -highlight">
              <div className="rt-table">
                <div className="rt-tbody">
                  {[
                    general.userHasType("admin", "secretario_regional", "chefe_nacional") && {
                      label: 'Exportar cursos e qualificações',
                      onClick: (e) => abrirFerramenta(<ListaParticipacoesCursos classes={classes}/>, e.target)
                    },
                    general.userHasType("admin", "secretario_regional", "chefe_nacional") && {
                      label: 'Exportar módulos e qualificações',
                      onClick: (e) => abrirFerramenta(<ListaParticipacoesModulos classes={classes}/>, e.target)
                    },
                    general.userHasType("admin") && {
                      label: 'Atualizar participações em cursos',
                      onClick: (e) => abrirFerramenta(<AtualizarEstadoParticipacao classes={classes}/>, e.target)
                    },
                    general.userHasType("admin") && {
                      label: 'Atualizar participação em percurso',
                      onClick: (e) => abrirFerramenta(<AtualizarParticipacaoPercurso classes={classes}/>, e.target)
                    },
                    general.userHasType("admin", "secretario_regional") && {
                      label: 'Atualizar dados de utilizador pelo SIIE',
                      onClick: (e) => abrirFerramenta(<AtualizarUtilizador classes={classes}/>, e.target)
                    },
                    general.userHasType("admin") && {
                      label: 'Cancelar participação em PRA',
                      onClick: (e) => abrirFerramenta(<CancelarFluxoUtilizadorPRA classes={classes}/>, e.target)
                    },
                    general.userHasType("admin") && {
                      label: 'Saltar fases de espera',
                      onClick: (e) => abrirFerramenta(<SaltarEspera classes={classes}/>, e.target)
                    },
                    general.userHasType("admin", "secretario_regional", "chefe_nacional") && {
                      label: 'Exportar interessados nos percursos de educadores',
                      onClick: (e) => abrirFerramenta(<ListaInteressadosPE classes={classes}/>, e.target)
                    },
                    general.userHasType("admin", "secretario_regional", "chefe_nacional") && {
                      label: 'Validar certificado de módulo',
                      onClick: (e) => abrirFerramenta(<ValidarCertificado classes={classes}/>, e.target)
                    },
                  ].filter(i => i).map(({label, onClick}, idx) => <div className="rt-tr-group">
                    <div className={"rt-tr -" + (idx % 2 === 0 ? "even" : "odd")}>
                      <div className="rt-td">{label}</div>
                      <div className="rt-td" style={{flex: 'initial'}}>
                        <Button className={classes.button + " " + classes.info} style={{height: 25}} onClick={onClick}>
                          Abrir
                        </Button>
                      </div>
                    </div>
                  </div>)}
                </div>
              </div>
              <div className="-loading">
                <div className="-loading-inner">Loading...</div>
              </div>
            </div>
          </Card>
          {ferramentaAberta && <Popper
            open={true}
            anchorEl={ferramentaAberta.anchorEl}
            transition
            placement="bottom-end"
            style={{zIndex: 999}}
          >
            {(popperProps) => (
              <div {...popperProps}>
                <ClickAwayListener onClickAway={(e) => {
                  // Existe um select aberto dentro da ferramenta
                  if (e.target.querySelector('div[role=presentation][class*=' + classes.selectMenu + ']')) {
                    return;
                  }
                  setFerramentaAberta(null)
                }}>
                  <div style={{maxWidth: 600, minWidth: 400}} onClick={e => e.stopPropagation()}>
                    {ferramentaAberta.content}
                  </div>
                </ClickAwayListener>
              </div>
            )}
          </Popper>}
        </GridItem>

        {general.userHasType("admin") && <>
          <GridItem xs={12} md={6}>
            <FAQGestao classes={classes}/>
          </GridItem>
        </>}
      </GridContainer>
    </div>
  </>);
}

export default withStyles(gestaoStyle)(Gestao);
